/* INTEGRATION STATE RESET */
export const INTEGRATION_STATE_INIT = "INTEGRATION_STATE_INIT"

/* CAMPAIGNS VK LIST DATA */
export const GET_VK_CAMPAIGNS_LIST = "GET_VK_CAMPAIGNS_LIST"
export const SET_VK_CAMPAIGNS_LIST = "SET_VK_CAMPAIGNS_LIST"

/* CLIENT VK DATA*/
export const GET_VK_CLIENT_LIST = "GET_VK_CLIENT_LIST";
export const SET_VK_CLIENT_LIST = "SET_VK_CLIENT_LIST";

/* BANNER VK DATA*/
export const GET_VK_BANNER_LIST = "GET_VK_BANNER_LIST";
export const SET_VK_BANNER_LIST = "SET_VK_BANNER_LIST";

/* LOADER VK CLIENT */
export const SHOW_VK_CLIENT_LOADER = "SHOW_VK_CLIENT_LOADER";
export const HIDE_VK_CLIENT_LOADER = "HIDE_VK_CLIENT_LOADER";

/* LOADER VK LIST */
export const SHOW_VK_CAMPAIGNS_LIST_LOADER = "SHOW_VK_CAMPAIGNS_LIST_LOADER"
export const HIDE_VK_CAMPAIGNS_LIST_LOADER = "HIDE_VK_CAMPAIGNS_LIST_LOADER"

/* LOADER VK BANNER LIST */
export const SHOW_VK_BANNERS_LIST_LOADER = "SHOW_VK_BANNERS_LIST_LOADER"
export const HIDE_VK_BANNERS_LIST_LOADER = "HIDE_VK_BANNERS_LIST_LOADER"

/* TikTok Advertisers */
export const GET_TIKTOK_ADVERTISERS_LIST = "GET_TIKTOK_ADVERTISERS_LIST"
export const SET_TIKTOK_ADVERTISERS_LIST = "SET_TIKTOK_ADVERTISERS_LIST"

/* Loader TikTok Advertisers */
export const SHOW_TIKTOK_ADVERTISERS_LIST_LOADER = "SHOW_TIKTOK_ADVERTISERS_LIST_LOADER"
export const HIDE_TIKTOK_ADVERTISERS_LIST_LOADER = "HIDE_TIKTOK_ADVERTISERS_LIST_LOADER"

/* MyTarget Agencies */
export const GET_MT_AGENCIES_LIST = "GET_MT_AGENCIES_LIST"
export const SET_MT_AGENCIES_LIST = "SET_MT_AGENCIES_LIST"

/* MyTarget Banners */
export const GET_MT_BANNERS_LIST = "GET_MT_BANNERS_LIST"
export const SET_MT_BANNERS_LIST = "SET_MT_BANNERS_LIST"

/* MyTarget Campaigns */
export const GET_MT_CAMPAIGNS_LIST = "GET_MT_CAMPAIGNS_LIST"
export const SET_MT_CAMPAIGNS_LIST = "SET_MT_CAMPAIGNS_LIST"

/* Loader MyTarget  */
export const SHOW_MT_AGENCIES_LIST_LOADER = "SHOW_TIKTOK_AGENCIES_LIST_LOADER"
export const HIDE_MT_AGENCIES_LIST_LOADER = "HIDE_TIKTOK_AGENCIES_LIST_LOADER"

/* Loader MyTarget  */
export const SHOW_MT_BANNERS_LIST_LOADER = "SHOW_TIKTOK_BANNERS_LIST_LOADER"
export const HIDE_MT_BANNERS_LIST_LOADER = "HIDE_TIKTOK_BANNERS_LIST_LOADER"

/* Loader MyTarget  */
export const SHOW_MT_CAMPAIGNS_LIST_LOADER = "SHOW_TIKTOK_CAMPAIGNS_LIST_LOADER"
export const HIDE_MT_CAMPAIGNS_LIST_LOADER = "HIDE_TIKTOK_CAMPAIGNS_LIST_LOADER"
